<template>
  <div class="main">
    <div class="d-allcenter" style="min-width: 663.28pt; width: 100vw">
      <!-- <button @click="printPdf" style="position: absolute; top: 50pt; left: 450pt" class="buttonNoPrint">导出</button> -->
      <!-- 手机端按钮 -->
      <el-button
        v-if="plat"
        round
        @click="getPdf()"
        style="
          position: fixed;
          top: 4rem;
          right: 1rem;
          z-index: 999;
          font-size: 2rem;
          background: #1a875f;
          color: #fff;
          box-shadow: 4px 4px 10px rgba(0, 0, 0, 0.2);
        "
        class="buttonNoPrint"
      >
        导出档案
      </el-button>
      <!-- 电脑端按钮 -->
      <el-button
        v-else
        round
        @click="printPdf"
        style="
          position: fixed;
          top: 8rem;
          left: 1rem;
          z-index: 999;
          font-size: 1.5rem;
          background: #1a875f;
          color: #fff;
          box-shadow: 4px 4px 10px rgba(0, 0, 0, 0.2);
        "
        class="buttonNoPrint"
      >
        导出档案
      </el-button>

      <div class="container" ref="pdfDom" style="width: 563.28pt; padding: 16pt">
        <!-- <div class="container" ref="pdfDom" style="width: 20cm; padding: 0.5cm"> -->
        <div class="topsearch">
          <div>
            <img src="@/assets/img/print/filename.svg" style="padding-top: 32pt" />
            <img src="@/assets/img/print/line.svg" style="width: 100%" />
          </div>
          <div class="d-between d-aligncnter mt-16">
            <div>
              <div style="font-size: 15pt" class="weight">{{ !!stuData.name ? stuData.name : '--' }}</div>
              <div class="d-aligncnter mt-8 grey">
                <div style="width: 134pt">学号：{{ !!stuData.stuNum ? stuData.stuNum : '--' }}</div>
                <div class="ml">性别：{{ !!stuData.gender ? stuData.gender : '--' }}</div>
                <div class="ml">年龄：{{ !!stuData.age ? stuData.age : '--' }}</div>
              </div>
              <div class="d-aligncnter mt-8 grey">
                <div style="width: 134pt">学院：{{ !!stuData.collegeName ? stuData.collegeName : '--' }}</div>
                <div class="ml">专业：{{ !!stuData.specialtyName ? stuData.specialtyName : '--' }}</div>
                <div class="ml">运动等级：{{ !!stuData.gradeType ? stuData.gradeType : '--' }}</div>
              </div>
              <div class="d-aligncnter mt-8 grey">
                <div style="width: 134pt">手机号：{{ !!stuData.mobile ? stuData.mobile : '--' }}</div>
                <div class="ml">邮箱：{{ !!stuData.email ? stuData.email : '--' }}</div>
              </div>
            </div>
            <div>
              <el-image style="width: 60pt; height: 80pt" :src="stuData.headImg" fit="contain"></el-image>
              <!-- <img style="width: 60pt; height: 80pt" :src="photo" fit="contain" /> -->
            </div>
          </div>
          <!-- 体质测试 -->
          <div class="mt-16 d-aligncnter">
            <div style="font-size: 15pt" class="weight">体质测试</div>
            <el-image style="width: 16pt; height: 14pt; margin-left: 8pt" :src="titleImg" fit="contain"></el-image>
          </div>
          <div style="padding: 2pt; margin-top: 8pt">
            <table class="tzcs-table">
              <!-- <tr class="printcolor" style="">
              <td v-for="(item, index) in tzcsThead" :key="'th_' + index">
                <div class="scaleMin" v-if="item.name != '年度'">({{ item.uint }})</div>
                <div>{{ item.name }}</div>
              </td>
            </tr> -->
              <tr class="printcolor" style="">
                <td v-for="(item, index) in tzcsThead" :key="'tzcs_th_' + index">
                  <div class="scaleMin" v-if="item.name != '年度'">({{ item.uint }})</div>
                  <div>{{ item.name }}</div>
                </td>
              </tr>
              <tr class="" style="" v-for="(tzcs, i) in tzcsData" :key="'tr_' + i">
                <td>{{ tzcs.year }}</td>
                <template v-for="(item, index) in tzcsThead">
                  <td :key="'tzcs_' + index" v-if="item.name != '年度' && !isJsonEmpty(tzcs.map)">
                    <div>{{ tzcs.map[item.name].data }}</div>
                    <div class="d-between tz-result green" v-if="item.name != '体重' && item.name != '身高'">
                      <div>{{ tzcs.map[item.name].score }}</div>
                      <div>{{ tzcs.map[item.name].level }}</div>
                    </div>
                  </td>
                </template>
              </tr>
            </table>
            <div v-if="tzcsData.length == 0" style="padding: 16px 0">暂无体质测试数据</div>
          </div>
          <!-- 体育成绩 -->
          <div class="mt-16 d-aligncnter">
            <div style="font-size: 15pt" class="weight">体育成绩</div>
            <el-image style="width: 16pt; height: 14pt; margin-left: 8pt" :src="titleImg" fit="contain"></el-image>
          </div>
          <div style="padding: 2pt; margin-top: 8pt">
            <table class="tycj-table">
              <tr class="printcolor" style="">
                <td v-for="(item, index) in tycjThead" :key="'tycj_th_' + index">
                  <div>{{ item.name }}</div>
                </td>
              </tr>
              <tr class="" style="" v-for="(tycj, i) in tycjData" :key="'tycj_' + i">
                <td style="width: 156pt">{{ tycj.termName }}</td>
                <td style="width: 88pt">{{ tycj.className }}</td>
                <td>{{ tycj.grade }}</td>
                <td>{{ tycj.attendance }}</td>
                <td>{{ tycj.theory }}</td>
                <td>{{ tycj.special }}</td>
                <td>{{ tycj.quality }}</td>
                <td>{{ tycj.exercise }}</td>
                <td>{{ tycj.competition }}</td>
              </tr>
            </table>
            <div v-if="tycjData.length == 0" style="padding: 16px 0">暂无体育成绩数据</div>
          </div>
          <!-- 课外锻炼 -->
          <div class="mt-16 d-aligncnter">
            <div style="font-size: 15pt" class="weight">课外锻炼</div>
            <el-image style="width: 16pt; height: 14pt; margin-left: 8pt" :src="titleImg" fit="contain"></el-image>
          </div>

          <div class="d-between mt-16">
            <div class="d-aligncnter">
              <el-image style="width: 16pt; height: 16pt; margin-right: 8pt" :src="tipsImg" fit="contain"></el-image
              >目标锻炼次数
            </div>
            <div class="target">{{ kwdlAll }}次</div>
          </div>
          <div class="mt-16">
            <el-progress
              :percentage="kwdlAll == 0 ? 100 : (kwdlNow / kwdlAll) * 100"
              :format="format"
              color="#339571"
            ></el-progress>
          </div>
          <div style="padding: 2pt; margin-top: 8pt">
            <table class="tycj-table">
              <tr class="printcolor" style="">
                <td v-for="(item, index) in kwdlThead" :key="'kwdl_th_' + index">
                  <div>{{ item.name }}</div>
                </td>
              </tr>
              <tr class="" style="" v-for="(tycj, i) in kwdlData" :key="'kwdl_' + i">
                <td style="width: 140pt">{{ tycj.termName }}{{ tycj.stageName }}</td>
                <td>{{ tycj.sumNum }}</td>
                <td>{{ tycj.sumDistance }}</td>
                <td>{{ tycj.exerciseNum }}</td>
                <td>{{ tycj.distance }}</td>
                <td style="width: 140pt" class="green">
                  <div v-for="ex in tycj.specialExerciseResList" :key="ex.name">
                    <span class="circle">·</span>{{ ex.type }}
                  </div>
                  <div v-if="tycj.specialExerciseResList.length == 0">-</div>
                </td>
                <td class="green">
                  <div v-for="ex in tycj.specialExerciseResList" :key="ex.name">
                    <span class="circle">·</span>{{ ex.count }}
                  </div>
                  <div v-if="tycj.specialExerciseResList.length == 0">-</div>
                </td>
                <td class="green">
                  <div v-for="ex in tycj.specialExerciseResList" :key="ex.name">
                    <span class="circle">·</span>{{ ex.distanceOutside }}
                  </div>
                  <div v-if="tycj.specialExerciseResList.length == 0">-</div>
                </td>
                <td>
                  <img v-if="tycj.player" src="@/assets/img/print/check-small.svg" /><img
                    v-else
                    src="@/assets/img/print/close-small.svg"
                  />
                </td>
                <td>
                  <img v-if="tycj.special" src="@/assets/img/print/check-small.svg" /><img
                    v-else
                    src="@/assets/img/print/close-small.svg"
                  />
                </td>
              </tr>
            </table>
            <div v-if="kwdlData.length == 0" style="padding: 16px 0">暂无课外锻炼数据</div>
          </div>
          <!-- 健康监测 -->
          <div class="mt-16 d-aligncnter">
            <div style="font-size: 15pt" class="weight">健康监测</div>
            <el-image style="width: 16pt; height: 14pt; margin-left: 8pt" :src="titleImg" fit="contain"></el-image>
          </div>
          <div style="padding: 2pt; margin-top: 8pt">
            <table class="jkjc-table">
              <tr class="printcolor" style="">
                <td v-for="(item, index) in jkjcThead" :key="'jkjc_th_' + index">
                  <div class="scaleMin" v-if="item.name != '年度' && item.name != '健康得分'">({{ item.uint }})</div>
                  <div>{{ item.name }}</div>
                </td>
              </tr>
              <tr class="" style="" v-for="(jkjc, i) in jkjcData" :key="'jkjc_' + i">
                <td>{{ jkjc.year }}</td>
                <td>{{ jkjc.score }}</td>
                <td>{{ jkjc.weight }}</td>
                <td>{{ jkjc.fat }}</td>
                <td>{{ jkjc.muscle }}</td>
                <td>{{ jkjc.water }}</td>
                <td>{{ jkjc.inFat }}</td>
                <td>{{ jkjc.subFat }}</td>
                <td>{{ jkjc.head }}</td>
                <td>{{ jkjc.protein }}</td>
                <td>{{ jkjc.bone }}</td>
                <td>{{ jkjc.shank }}</td>
              </tr>
            </table>
            <div v-if="jkjcData.length == 0" style="padding: 16px 0">暂无健康监测数据</div>
          </div>
          <!-- 比赛成绩 -->
          <div class="mt-16 d-aligncnter">
            <div style="font-size: 15pt" class="weight">比赛成绩</div>
            <el-image style="width: 16pt; height: 14pt; margin-left: 8pt" :src="titleImg" fit="contain"></el-image>
          </div>
          <div v-if="raceData.length == 0" style="padding: 16px 0">暂无比赛成绩</div>
          <div class="mt-16" v-for="(item, index) in raceData" :key="'race_' + index">
            <div class="d-aligncnter">
              <el-image style="width: 16pt; height: 16pt; margin-right: 8pt" :src="planImg" fit="contain"></el-image
              >{{ item.year }}年度
            </div>
            <div class="" style="border: 1pt solid #e8e8e8; border-radius: 16pt; padding: 16pt; margin-top: 8pt">
              <div class="d-between" v-for="(each, i) in item.raceRankResList" :key="'list_' + i" style="margin: 2pt">
                <div>{{ each.raceName }}</div>
                <div>{{ each.rank }}</div>
              </div>
            </div>
          </div>
          <!-- 比赛成绩结束 -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import print from 'print-js'
// import html2canvas from 'html2canvas'
// import { downloadPDF } from './pdf.js' //工具方法，导出操作
import {
  getStuInfo,
  getMyHealthGrade,
  getStuTyGradeList,
  getMyExercise,
  getMyHealthMonitor,
  getMyRaceInfo,
} from '@/api/api-print'
// import utils from '@/assets/js/util.js'
export default {
  name: 'pdf',
  data() {
    return {
      isShow: false,
      htmlTitle: '页面导出PDF文件名',
      photo: require('@/assets/img/print/photo.svg'),
      titleImg: require('@/assets/img/print/titleimg.svg'),
      tipsImg: require('@/assets/img/print/tips.svg'),
      planImg: require('@/assets/img/print/plan.svg'),
      tzcsThead: [],
      tzcsTheadBoy: [
        { name: '年度', uint: null },
        { name: '体重', uint: '千克' },
        { name: '身高', uint: '厘米' },
        { name: '体重指数', uint: '千克/立方米' },
        { name: '肺活量', uint: '毫升' },
        { name: '坐位体前屈', uint: '厘米' },
        { name: '立定跳远', uint: '厘米' },
        { name: '引体向上', uint: '个' },
        { name: '50米', uint: '秒' },
        { name: '1000米', uint: '分·秒' },
      ],
      tzcsTheadGirl: [
        { name: '年度', uint: null },
        { name: '体重', uint: 'kg' },
        { name: '身高', uint: 'cm' },
        { name: '体重指数', uint: 'kg/m²' },
        { name: '肺活量', uint: 'ml' },
        { name: '坐位体前屈', uint: 'cm' },
        { name: '立定跳远', uint: 'cm' },
        { name: '一分钟仰卧起坐', uint: '个' },
        { name: '50米', uint: '秒' },
        { name: '800米', uint: '分·秒' },
      ],
      tzcsThead2: [
        { name: '体重', uint: '千克' },
        { name: '身高', uint: '厘米' },
        { name: '体重指数', uint: '千克/立方米' },
        { name: '肺活量', uint: '毫升' },
        { name: '坐位体前屈', uint: '厘米' },
        { name: '立定跳远', uint: '厘米' },
        { name: '引体向上', uint: '个' },
        { name: '50米', uint: '秒' },
        { name: '1000米', uint: '分·秒' },
      ],
      tzcsData: [],
      tycjThead: [
        { name: '学期名称' },
        { name: '教学班名称' },
        { name: '总分' },
        { name: '平时成绩' },
        { name: '体育理论' },
        { name: '专项技术' },
        { name: '身体素质' },
        { name: '课外锻炼' },
        { name: '校园竞赛' },
      ],
      tycjData: [],
      kwdlThead: [
        { name: '学期名称' },
        { name: '合计锻炼次数' },
        { name: '合计公里数' },
        { name: '锻炼次数' },
        { name: '跑步公里数' },
        { name: '附加项目' },
        { name: '附加锻炼次数' },
        { name: '附加公里数' },
        { name: '运动员' },
        { name: '特殊生' },
      ],
      kwdlData: [],
      kwdlAll: 0,
      kwdlNow: 0,
      jkjcThead: [
        { name: '年度', uint: '' },
        { name: '健康得分', uint: '' },
        { name: '体重', uint: 'kg' },
        { name: '体脂率', uint: '%' },
        { name: '肌肉率', uint: '%' },
        { name: '水分', uint: '%' },
        { name: '内脏脂肪', uint: '%' },
        { name: '皮下脂肪', uint: '%' },
        { name: '去脂体重', uint: 'kg' },
        { name: '蛋白质', uint: '%' },
        { name: '骨量', uint: 'kg' },
        { name: '骨骼肌重量', uint: 'kg' },
      ],
      jkjcData: [],
      raceData: [
        {
          year: '2023',
          list: [
            { name: '奋进杯', rank: '第一名' },
            { name: '奋进杯', rank: '第一名' },
          ],
        },
        {
          year: '2022',
          list: [
            { name: '奋进杯', rank: '第一名' },
            { name: '奋进杯', rank: '第一名' },
          ],
        },
      ],
      plat: false,
      routeQuery: '',
      currId: '',
      stuData: {},
    }
  },
  mounted() {
    //判断打开平台
    this.plat = this._isMobile()
    this.routeQuery = this.$route.query
    console.log('routeQuery:', this.routeQuery)

    // this.currId = utils.aesDecrypt(this.routeQuery.data)
    this.currId = this.routeQuery.data
    console.log('routeQuery!!', this.currId)
    //基本信息
    getStuInfo(this.currId).then((res) => {
      if (res.data.statusCode == 1) {
        console.log('res', res)
        this.htmlTitle = res.data.obj.name + '-' + res.data.obj.stuNum
        this.stuData = res.data.obj
        this.getBase64Image(this.stuData.headImg, (dataURL) => {
          console.log('dataURL:', dataURL)
          this.stuData.headImg = dataURL
        })
        this.initWatermark()

        if (this.stuData.gender == '女') {
          this.tzcsThead = this.tzcsTheadGirl
        } else {
          this.tzcsThead = this.tzcsTheadBoy
        }
      }
    })
    getMyHealthGrade(this.currId).then((res) => {
      if (res.data.statusCode == 1) {
        console.log('res', res)
        this.tzcsData = res.data.obj
      }
    })
    getStuTyGradeList(this.currId).then((res) => {
      if (res.data.statusCode == 1) {
        console.log('res', res)
        this.tycjData = res.data.obj
      }
    })
    getMyExercise(this.currId).then((res) => {
      if (res.data.statusCode == 1) {
        console.log('res', res)
        this.kwdlData = res.data.obj.exerciseInfoResList
        this.kwdlAll = res.data.obj.targetNumber
        this.kwdlNow = res.data.obj.count
      }
    })
    getMyHealthMonitor(this.currId).then((res) => {
      if (res.data.statusCode == 1) {
        console.log('res', res)
        this.jkjcData = res.data.obj
      }
    })
    getMyRaceInfo(this.currId).then((res) => {
      if (res.data.statusCode == 1) {
        console.log('res', res)
        this.raceData = res.data.obj
      }
    })

    this.handleWatermark()
  },
  methods: {
    // handleExport() {
    //   downloadPDF(this.$refs.pdf)
    // },
    _isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      )
      return flag
    },
    displaythis() {
      this.isShow
    },
    printPdf() {
      this.onbeforePrint()
      window.print()
    },
    onbeforePrint() {
      //先获取div的高度，当高度小于800pt时，需要设置距离顶部的值，大于800则已经铺满整个A4纸，不用设置
      var style = document.createElement('style')
      //   var mapHeight = $('#map').height()
      //   var marginTop = '0mm'
      //   if (mapHeight < 800) {
      //     var temp = 800 - parseInt(mapHeight)
      //     marginTop = (temp / 8).toFixed(2) + 'mm'
      //   }
      style.innerHTML = '@page{size: portrait;}'
      window.document.head.appendChild(style)
    },
    format(percentage) {
      return percentage === this.kwdlAll ? '已达标' : this.kwdlNow + `次`
    },
    getBase64Image(url, callback) {
      var image = new Image()
      image.src = url + '?v=' + Math.random() // 处理缓存
      image.crossOrigin = '*' // 支持跨域图片
      image.onload = () => {
        var canvas = document.createElement('canvas')
        var context = canvas.getContext('2d')
        canvas.width = image.width
        canvas.height = image.height
        context.drawImage(image, 0, 0, image.width, image.height)
        const ndata = canvas.toDataURL('image/jpeg', 1.0)
        callback ? callback(ndata) : null
      }
    },
    //水印
    initWatermark() {
      // 创建一个canvas
      const canvas = document.createElement('canvas')
      // 设置画布的宽高
      canvas.width = 150
      canvas.height = 150
      // 获取画笔
      const ctx = canvas.getContext('2d')
      // 水印，水印实际上就是将文字添加到画布上
      ctx.font = '10px Arial' // 设置字体大小和字体
      ctx.rotate(-0.4) // 设置文字旋转角度

      // 创建实体水印
      ctx.fillStyle = 'rgba(0,0,0,.2)' // 颜色
      ctx.fillText(this.stuData.stuNum + '-' + this.stuData.name, canvas.width / 6, canvas.height / 2) // 设置显示文字和偏移量

      // 创建虚心水印
      // ctx.strokeStyle = 'rgba(0,0,0,.3)';
      // ctx?.strokeText('这是水印', canvas.width / 6, canvas.height / 2);

      // 渐变水印
      // const gradient = ctx.createLinearGradient(0, 0, canvas.width, 0);
      // gradient.addColorStop(0, 'red');
      // gradient.addColorStop(0.5, 'yellow');
      // gradient.addColorStop(1, 'green');
      // ctx.fillStyle = gradient; // 颜色
      // ctx.fillText('这是水印', canvas.width / 6, canvas.height / 2);// 设置显示文字和偏移量

      // 将画布转成图片
      const img = canvas.toDataURL()
      console.log('img:', img)
      const main = document.querySelector('.topsearch')
      main.style.backgroundImage = `url(${img})`
    },
    // 监听水印移除后重加，防止水印被移除
    handleWatermark() {
      // 获取需要观察的节点
      const target = document.querySelector('.topsearch')
      // 观察器配置
      const config = {
        attributes: true, // 监听目标元素属性的变化
        childList: true, // 监听目标原型子节点的变化
        subtree: false, // 是否观察后代的变化。默认false
      }
      // 创建观察器
      const observer = new MutationObserver((abc) => {
        console.log(abc)
        // 获取背景图片
        const bgi = target?.style?.backgroundImage
        console.log('背景的值：', bgi)
        if (!bgi) {
          // 当背景被取消后，重新添加
          this.initWatermark()
        }
      })
      // 开始观察
      observer.observe(target, config)
      // 停止观察
      // observer.disconnect()
    },
    isJsonEmpty(jsonObj) {
      return Object.keys(jsonObj).length === 0
    },
  },
}
</script>
<style scoped lang="scss">
.none {
  display: none;
}
.mt-16 {
  margin-top: 16pt;
}
.mt-8 {
  margin-top: 8pt;
}
.ml {
  margin-left: 1.5cm;
}
.grey {
  color: #8b8b8bcc;
}
.phoneHide {
  display: none;
}
@media print {
  .buttonNoPrint {
    display: none;
  }
  .printcolor {
    background-color: linear-gradient(92.47deg, #19c384 0.01%, #1aa4fe 104.18%);
    color: #fff;
    font-size: 9pt;
  }
  .phoneHide {
    display: unset;
  }
  div {
    -webkit-print-color-adjust: exact;
    -moz-print-color-adjust: exact;
    -ms-print-color-adjust: exact;
    print-color-adjust: exact;
  }
  @page {
    // 纵向
    size: portrait;
    margin-bottom: 0mm;
    margin-top: 0mm;
  }
}
.printcolor {
  background: linear-gradient(92.47deg, #19c384 0.01%, #1aa4fe 104.18%);
  color: #fff;
  font-size: 9pt;
}
.tzcs-table td {
  width: 74pt;
  text-align: center;
  padding: 8pt 2pt;
}
.tycj-table td {
  text-align: center;
  padding: 8pt 2pt;
  width: 74pt;
}
.kwdl-table td {
  text-align: center;
  padding: 8pt 2pt;
  //   width: 60pt;
}
.jkjc-table td {
  text-align: center;
  padding: 8pt 2pt;
  width: 74pt;
}
table {
  font-size: 9pt;
  border-collapse: collapse;
  border: 1pt solid #ededed;
  th,
  td {
    text-align: center;
    border: 1pt solid #ededed;
  }
  .td-bg {
    background: #007a4d33;
  }
}
.scaleMin {
  transform: scale(0.8);
}
.tz-result {
  font-size: 9pt;
  transform: scale(0.8);
}
.green {
  color: #007a4d;
}
.target {
  background: #e6f2ed;
  color: #007a4d;
  border-radius: 30pt;
  padding: 2pt 8pt;
  font-size: 9pt;
}
.circle {
  font-size: 14px;
  font-weight: 600;
  margin-right: 2px;
}
.main {
  width: 100vw;
  min-width: 563pt;
  z-index: 999;
  //   background: url('../../assets/img/print/plan.svg') repeat;
}
// .topsearch {
//   background: url('../../assets/img/print/download.png') repeat;
// }
</style>
